import Modal from 'components/Modal'
import Identification from 'views/MerchantProfile/ManualTx/Identification'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalIdentification = ({ title, open, onClose }: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <Identification onClose={onClose} />
    </Modal>
  )
}

export default ModalIdentification
